import request from "../utils/fetch";
import { paramsToUrl } from "@/utils/paramsToUrl";
//合伙人列表
export function partnerList(data) {
  return request({
    url: "/user/partner/pc/company/list" + paramsToUrl(data),
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

//合伙人删除
export function partnerDel(data) {
  return request({
    url: "/user/partner/pc/delete",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

// 新增企业合伙人
export function partnerAdd(data) {
  return request({
    url: "/user/partner/pc/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

// 维护人员下拉
export function weihuPeoplePull(data) {
  return request({
    url: "/user/afterSales/user/pullList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 合伙人详情
export function partnerDetail(data) {
  return request({
    url: "/user/partner/pc/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 合伙人编辑
export function partnerEdit(data) {
  return request({
    url: "/user/partner/pc/update",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

// 查看分润信息
export function shareInfo(data) {
  return request({
    url: "/order/company/partner/share/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 分润列表
export function shareList(data) {
  return request({
    url: "/order/company/partner/share/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 分润统计
export function shareStat(data) {
  return request({
    url: "/order/company/partner/share/statistics",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 区域回收
export function quyuHuiShou(data) {
  return request({
    url: "/user/partner/pc/del/region",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

//合伙人区域列表
export function quyuLiebiao(data) {
  return request({
    url: "/user/partner/pc/info/region",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 分润导出
export function shareExport(data) {
  return request({
    url: "/order/company/partner/share/export",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
    header: {
      headers: { "Content-Type": "application/x-download" }
    },
    responseType: "blob"
  });
}

// 提现记录列表
export function tixianList(data) {
  return request({
    url: "/order/company/partner/withdraw/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 提现跟进
export function tixianFollow(data) {
  return request({
    url: "/order/company/partner/withdraw/follow",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

// 提现统计
export function tixianState(data) {
  return request({
    url: "/order/company/partner/withdraw/statistics",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 提现导出
export function tixianExport(data) {
  return request({
    url: "/order/company/partner/withdraw/export",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
    header: {
      headers: { "Content-Type": "application/x-download" }
    },
    responseType: "blob"
  });
}
//提现设置
export function tixianSetting(data) {
  return request({
    url: "/user/partner/pc/withdraw/setting",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}
// 合伙人申请列表
export function applyList(data) {
  return request({
    url: "/user/partner/pc/apply/list" + paramsToUrl(data),
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

// 分区里合伙人列表
export function regionPartnerList(data) {
  return request({
    url: "/user/partner/region/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

// 根据分区查详情
export function regionDetail(data) {
  return request({
    url: "/user/partner/pc/region/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 获取合伙人申请信息
export function getPartnerApplyInfo(data) {
  return request({
    url: "/user/partner/pc/apply/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}
//合伙人详情-合伙人区域列表
export function getPartnerApplyRegionList(data) {
  return request({
    url: "/user/partner/pc/info/region",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 获取合伙人申请通过驳回
export function partnerApplyCheck(data) {
  return request({
    url: "/user/partner/pc/apply/audit",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

// 合伙人统计
export function partnerState(data) {
  return request({
    url: "/user/partner/pc/company/statistics",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

// 合伙人冻结
export function partnerFreeze(data) {
  return request({
    url: "/user/partner/pc/freeze",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

// 合伙人解锁
export function partnerUnlock(data) {
  return request({
    url: "/user/partner/pc/unlock",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

// 合伙人解冻
export function partnerUnfreeze(data) {
  return request({
    url: "/user/partner/pc/unfreeze",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}

//查询所有合伙人对应维护人分润列表
export function partnerMaintainerShareTotalList(data) {
  return request({
    url: "/order/partnerMaintainerShare/total/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}
//查询所有合伙人对应维护人分润统计
export function partnerMaintainerShareTotal(data) {
  return request({
    url: "/order/partnerMaintainerShare/total",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data
  });
}
//获取维护人分润列表
export function partnerMaintainerShareList(data) {
  return request({
    url: "/order/partnerMaintainerShare/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}
//统计维护人分润列表
export function partnerMaintainerShareStatistics(data) {
  return request({
    url: "/order/partnerMaintainerShare/statistics",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}

//获取导出合伙人对应维护人分润表数量
export function getPartnerMaintainerShareExportNum(data) {
  return request({
    url: "/order/partnerMaintainerShare/export",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data
  });
}
//导出合伙人对应维护人分润表
export function partnerMaintainerShareExport(data) {
  return request({
    url: "/order/partnerMaintainerShare/export",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    header: {
      headers: { "Content-Type": "application/x-download" }
    },
    responseType: "blob"
  });
}
